import { ExternalResource, ExternalResourceWithConfig, getProjectLinkConfigByName } from 'domain/shared/newProject';

/** Return resources sorted by the fixed order. */
export function orderExternalResources(resources?: ExternalResource[]): ExternalResourceWithConfig[] {
  return (resources || [])
    .filter(r => !!r.name && !!r.value)
    .map(r => {
      const config = getProjectLinkConfigByName(r.name);

      return {
        ...r,
        config: {
          ...config,
          displayName: config.displayName || r.name,
        },
      };
    })
    .sort((a, b) => {
      const priorityA = a.config.priority ?? Infinity;
      const priorityB = b.config.priority ?? Infinity;
      return priorityA - priorityB;
    });
}
